<template>
  <div class="vue-bulma">
    <!-- Modal -->
    <div class="modal" :class="{ 'is-active': showModal }">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Bulma Modal</p>
          <button class="delete" aria-label="close" @click="closeModal"></button>
        </header>
        <section class="modal-card-body" style="background: white;">
          <p>This modal appears when you press the "G" key.</p>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary" @click="closeModal">Close</button>
        </footer>
      </div>
    </div>
    <!-- /Modal -->
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const showModal = ref(false)

function closeModal() {
  showModal.value = false
}

onMounted(() => {
  // bind events
})

onBeforeUnmount(() => {
  // unbind events
})
</script>

<style scoped>
p { color: purple; }
</style>
